import { Country } from '../../models/country.model';
import { CountryState } from './state.interface';

export const InitialCountryState: CountryState = {
    liveCountries: [] as Country[],
    gettingLiveCountries: false,
    gettingLiveCountriesSuccess: false,
    gettingLiveCountriesFailure: ''
};
